import React from 'react';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyUnlockOperations = lazyForPaint<any>(
	() =>
		import(
			/* webpackChunkName: "async-jira-eoc-unlock-operations", jiraSpaEntry: "async-jira-eoc-unlock-operations" */ '@atlassian/jira-eoc-unlock-operations'
		),
);

const AsyncUnlockOperations = (): React.JSX.Element => (
	<LazyPage
		Page={LazyUnlockOperations}
		pageId="eoc-products-unlock-operations"
		shouldShowSpinner={false}
	/>
);

export default AsyncUnlockOperations;
